import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Observable, of, throwError } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { Environment } from '../../../environment';
import {
  Delivery,
  GetDeliveriesResponse,
  ActiveDelivery,
  PostManualDeliveryRequest,
  ShowInFinalSetupDeliveryRequest,
} from '../models/flock-registration-service.model';

@Injectable({
  providedIn: 'root',
})
export class FlockRegistrationDeliveryService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/flock-registration/secure`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getDeliveries(startDate?: string, endDate?: string): Observable<Delivery[] | HttpErrorResponse> {
    const params: { [p: string]: string } = {};

    if (startDate) {
      params['startDate'] = `${new Date(startDate).toISOString().slice(0, 10)}`;
    }

    if (endDate) {
      params['endDate'] = `${new Date(endDate).toISOString().slice(0, 10)}`;
    }

    return this.http.get<GetDeliveriesResponse>(`${this.baseUrl}/delivery`, { params }).pipe(
      map((response) => response.deliveries),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Delivery[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  upsertActiveDeliveries(activeDelivery: ActiveDelivery): Observable<ActiveDelivery> {
    return this.http.post<ActiveDelivery>(`${this.baseUrl}/delivery/active`, activeDelivery, {});
  }

  removeManualDelivery(manualDeliveryId: number) {
    return this.http.delete(`${this.baseUrl}/manualdelivery/${manualDeliveryId}`);
  }

  upsertManualDelivery(manualDeliveryRequest: PostManualDeliveryRequest): Observable<number> {
    return this.http.post<number>(`${this.baseUrl}/manualdelivery`, manualDeliveryRequest, {});
  }

  upsertShowInFinalSetupDeliveries(request: ShowInFinalSetupDeliveryRequest): Observable<number> {
    return this.http.post<number>(`${this.baseUrl}/delivery/showinfinalsetup`, request, {});
  }
}
